<ng-container *ngIf="historyItem && historyItem.record">
  <opac-card-item
    [title]="baseData.title"
    [author]="baseData.author"
    [cover]="coverDetails"
    [link]="historyItem.record | infoUrl"
    [progress]="progressDetails"
  >
    <opac-card-item-social>
      <app-rating class="interactions__rating" [record]="historyItem?.record"></app-rating>
      <app-favorite-button [recordId]="historyItem?.recordId"></app-favorite-button>
      <app-more-option-button
        [recordItem]="historyItem?.record"
        [historyItem]="historyItem"
        [isHistoryItem]="true"
        [certificateSection]="true"
        (removed)="onRemoved($event)">
      </app-more-option-button>
    </opac-card-item-social>

    <opac-card-item-details>
      <opac-card-item-detail *ngIf="historyItem.percentage > 0" [label]="'history.item_progress' | translate">{{ historyItem.percentage }}%</opac-card-item-detail>
      <opac-card-item-detail *ngIf="historyItem.completed" [label]="'history.item_status.label' | translate">
        <span class="completed-status-container">
          <opac-icon icon="check_black"></opac-icon>
          {{ 'history.item_status.completed' | translate }}
        </span>
      </opac-card-item-detail>
    </opac-card-item-details>

    <app-record-buttons
      *ngIf="showRecordButtons"
      [class.app-record-buttons-inactive]="!historyItem?.record?.active"
      from="USER_SCREENS"
      [record]="historyItem?.record"
      [config]="config"
      [historyItem]="historyItem"
      [physicalRecord]="physicalRecord"
      [certificateSection]="true">
    </app-record-buttons>
  </opac-card-item>
